import * as Sentry from '@sentry/vue'
// import './assets/main.css'
import ElementPlus from 'element-plus'
import { createPinia } from 'pinia'
import { createApp } from 'vue'

import App from './App.vue'
import router from './router'
import 'element-plus/dist/index.css'

const app = createApp(App)

app.use(ElementPlus)
app.use(createPinia())
app.use(router)

app.mount('#app')

Sentry.init({
  app,
  dsn: 'http://bdedff102d6f965be9fbd07b5da96455@ec2-52-81-210-57.cn-north-1.compute.amazonaws.com.cn:9000/10',
  // dsn: 'https://1c2aeaa7eca178b020ce5bf9009b42de@o4507910703742976.ingest.us.sentry.io/4508172432310272',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/spatialwalk-usa\.zeabur\.app/],
  // Session Replay
  replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})
